import { Controller } from 'stimulus';

export default class extends Controller {
  closeWindow() {
    const win = window.open("","_self")
    win.close()
  }
}